import { useTranslation } from 'react-i18next';
import React, { useContext, useEffect } from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { ScmDataBox } from "./scmStatistic/DataBox";
import { MyContext } from "@/store/myContext";
import { useStockStatisticModel } from "../stockStatisticModel";

export default () => {
    
const { t } = useTranslation();
const { state } = useContext(MyContext);
    const { searchParam, getMdShopList } = useStockStatisticModel(({ searchParam }) => [searchParam]);

    useEffect(() => {
        getMdShopList()
    }, [])

    return (
        <>
            {state.activeMenu === "stockStatistic" && <>
                <PageHeader />
                {
                    // searchParam.outerShopId ? <ScmDataBox /> : <DataBox /> 
                    searchParam.diffField === "机构" ? <DataBox /> : <ScmDataBox />
                }
            </>}
        </>
    )
}